import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useFormFields } from '../../../libs/hooksLib';
import { isNilOrEmpty } from '../../../utils/objectUtils';
import { signup } from '../../../store/user';
import { onError } from '../../../libs/errorLib';

const useSignup = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [fields, handleFieldChange] = useFormFields({
        email: '',
        password: '',
        confirmPassword: '',
    });
    const [isLoading, setIsLoading] = useState(false);

    function validateForm() {
        return (
            !isNilOrEmpty(fields.email) &&
            !isNilOrEmpty(fields.password) &&
            fields.password === fields.confirmPassword
        );
    }

    const signupEvent = async (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();

        setIsLoading(true);

        try {
            await dispatch(signup(fields));

            history.push('/signupConfirmation');
        } catch (error) {
            onError(error);
            setIsLoading(false);
        }
    };
    return { fields, handleFieldChange, isLoading, validateForm, signupEvent };
};

export default useSignup;
